import React from "react";
import { Badge } from "@/components/Badge";
import { useBundleContext } from "./BundleContext";

export const BundleDetails = () => {
  const { bundle } = useBundleContext();
  return (
    <div className="flex items-center space-x-2">
      <p className="body text-sm">{bundle.profiles[0].products.length} items</p>
      <Badge color="green" size="base" bordered pill>
        <div>
          <span className="font-bold">{bundle.discountPercent}%</span>{" "}
          <span>discount</span>
        </div>
      </Badge>
    </div>
  );
};
